/* eslint-disable no-unused-vars */
import { mapActions, mapGetters, mapState } from 'vuex';
import socialLevelMixin from '@/mixins/socialLevel';
import accountVerifyMixin from '@/mixins/accountVerify';
import loaderMixin from '@/mixins/loader';
import accountSocialBadge from '@/components/account/account-social-badge/account-social-badge.vue';
import userAgentMixin from '@/mixins/userAgent';

export default {
  mixins: [
    accountVerifyMixin,
    loaderMixin,
    socialLevelMixin,
    userAgentMixin,
  ],
  components: {
    accountSocialBadge,
  },
  data() {
    return {
      name: null,
      accountBalance: null,
      portfolioBalance: null,
      currency: null,
    };
  },
  metaInfo() {
    if (this.isLayoutMobile) {
      return {
        title: 'Account',
      };
    }
    return {};
  },
  computed: {
    ...mapState('wallet', ['balance']),
    ...mapGetters('app', ['hasMaintenanceMessage', 'isLayoutMobile']),
    enabledLinks() {
      return this.links.filter(i => i.enabled);
    },
    links() {
      const route = this.$route;
      const query = this.$route.query;

      return [
        {
          type: 'header',
          name: 'Wallet',
          enabled: true,
        },
        {
          name: 'Deposit',
          type: 'link',
          inner: true,
          to: { name: 'wallet', query: { tabId: 'deposit' } },
          active: route.name === 'wallet' && query.tabId === 'deposit',
          enabled: true,
        },
        {
          name: 'Withdraw',
          type: 'link',
          inner: true,
          to: { name: 'wallet', query: { tabId: 'withdraw' } },
          active: route.name === 'wallet' && query.tabId === 'withdraw',
          enabled: true,
        },
        {
          type: 'line',
          name: 'Line1',
          enabled: true,
        },
        {
          type: 'header',
          name: 'History',
          enabled: true,
        },
        {
          name: 'Trades',
          type: 'link',
          inner: true,
          to: { name: 'account-history', query: { tabId: 'trades' } },
          active: route.name === 'account-history' && (query.tabId === 'trades' || route.params.marketId),
          enabled: true,
        },
        {
          name: 'Deposits / Withdrawals',
          type: 'link',
          inner: true,
          to: { name: 'account-history', query: { tabId: 'deposit-withdrawals' } },
          active: route.name === 'account-history' && query.tabId === 'deposit-withdrawals',
          enabled: true,
        },
        {
          type: 'line',
          name: 'Line2',
          enabled: true,
        },
        {
          name: 'Account Details',
          type: 'link',
          to: { name: 'account-details' },
          active: route.name === 'account-details',
          enabled: true,
        },
        {
          name: 'Settings',
          type: 'link',
          to: { name: 'account-settings' },
          active: route.name === 'account-settings',
          enabled: true,
        },
        {
          name: 'Help and Support',
          type: 'link',
          to: { name: 'HelpAndSupport' },
          active: [
            'HelpAndSupport',
            'WhatIsPredictIt',
            'LearnTheBasics',
            'ComunityForums',
            'Faq',
            'Videos',
          ].includes(route.name),
          enabled: true,
        },
        {
          type: 'line',
          name: 'Line3',
          enabled: true,
        },
        {
          type: 'logout',
          name: 'LOGOUT',
          enabled: true,
        },
      ]
    },
    cash() {
      return (Math.floor(this.balance.accountBalanceDecimal * 100) / 100).toFixed(2);
    },
  },
  methods: {
    ...mapActions('user', ['logout']),
    profileButtonClass(link) {
      return {
        profile__button: true,
        'profile__button--inner': link.inner,
        'profile__button--active': link.active,
      };
    },
    logoutButton() {
      this.loaderAdd(document.body);
      this.logout();
      this.$gtm.trackEvent({ event: 'Logout' });
    },
    isLinkAvailable(link) {
      const walletCheckNames = ['Deposit', 'Withdraw', 'Wallet', 'Line1'];
      if (walletCheckNames.includes(link.name)) {
        return this.isWalletEnabled;
      }
      return true;
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/account/profile/profile.js